<template>
    <div class="bg-[#02130E] fixed w-full h-full">
        <div class="w-10 h-10 rounded-full animate-spin border-solid border-4 border-[#CA3F79] border-t-transparent absolute top-[50%] left-[50%] ml-[-20px]"></div>
    </div>
</template>

<script>
    export default {
        name: 'LoadingView'
    }
</script>
